import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const getSessionId = () => {
    let sid = localStorage.getItem("clonzo_sid");
    if (!sid) { sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem("clonzo_sid", sid); }
    return sid;
};

export const trackProductView = (productId) => {
    try { api.post(`/products/${productId}/view`, { session_id: getSessionId() }); } catch {}
};

export default function ProductCard({ product, testId }) {
    const img = (product.images && product.images[0]) || "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=600";
    const onSale = product.on_sale;
    const price = onSale ? product.sale_price : product.price;
    const original = onSale ? product.original_price : (product.compare_at_price && product.compare_at_price > product.price ? product.compare_at_price : null);
    const discountPct = onSale ? product.discount_percent : (original ? Math.round((1 - product.price / original) * 100) : 0);
    return (
        <Link to={`/product/${product.slug || product.id}`} onClick={() => trackProductView(product.id)} data-testid={testId || `product-card-${product.id}`} className="group block">
            <div className="relative bg-white border-2 border-black overflow-hidden">
                <div className="aspect-[4/5] overflow-hidden">
                    <img src={img} alt={product.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                {onSale ? (
                    <div className="absolute top-3 left-3 text-white font-mono text-[10px] uppercase px-2 py-1 tracking-widest" style={{ background: "hsl(var(--accent))" }} data-testid={`sale-badge-${product.id}`}>
                        SALE · -{discountPct}%
                    </div>
                ) : discountPct > 0 && (
                    <div className="absolute top-3 left-3 bg-black text-white font-mono text-[10px] uppercase px-2 py-1 tracking-widest">-{discountPct}%</div>
                )}
                {product.tags?.includes("new") && (
                    <div className="absolute top-3 right-3 bg-black text-white font-mono text-[10px] uppercase px-2 py-1 tracking-widest">New</div>
                )}
            </div>
            <div className="mt-3 flex items-start justify-between gap-3">
                <div>
                    <div className="font-display text-lg leading-tight">{product.name}</div>
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mt-1">{product.gender} • {product.category_slug}</div>
                </div>
                <div className="text-right">
                    <div className="font-display text-lg" style={onSale ? { color: "hsl(var(--accent))" } : {}}>₹{Math.round(price)}</div>
                    {original && <div className="font-mono text-xs text-neutral-500 line-through">₹{Math.round(original)}</div>}
                </div>
            </div>
        </Link>
    );
}
